import { render, staticRenderFns } from "./Coordinate.vue?vue&type=template&id=5da53ad4"
import script from "./Coordinate.vue?vue&type=script&lang=js"
export * from "./Coordinate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports